<style>
.btn-img-edit{
  position: absolute;
  top: 93px;
  left:93px;
}
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div class="relative">
                          <vs-avatar :src="logo" size="120px" />
                          <input type="file" id="file" ref="file" @change="handleFileUpload()" class="hidden"/>
                          <vs-button radius color="primary" type="filled" icon="edit" @click="$refs.file.click()" class="btn-img-edit"/>
                        </div>
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Name')" :placeholder="$t('Labels.Name')" v-model="data.name"/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.Address')" :placeholder="$t('Labels.Address')" v-model="data.address"/>
                          </div>
                        </div>
                        <div class="flex">
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.ContactName')" :placeholder="$t('Labels.ContactName')" v-model="data.contact_name"/>
                          </div>
                          <div class="flex-1 p-2">
                            <vs-input class="w-full" :label="$t('Labels.PhoneNumber')" :placeholder="$t('Labels.PhoneNumber')" v-model="data.phone_number" v-mask="'###-###-##-##'"/>
                          </div>
                        </div>
                        <div class="text-right">
                          <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled" :disabled="!valid">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect
  },

  data () {
    return {
      uuid: this.$route.params.uuid,
      data:{
        name: '',
        address: '',
        contact_name: '',
        phone_number: ''
      },
      logo: '',
      file: ''
    }
  },

  methods: {
    async init () {
      const params = {
        url: `companies/${this.uuid}`,
        method: 'GET',
        params: {
          limit: 0
        }
      }
      await request(params).then(response => {
        this.data = response.data.data
        this.logo = `data:image/jpeg;base64,${  this.data.image}`
      })             
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      this.data.phone_number = this.data.phone_number.replaceAll('-', '')
      const params = {
        url: `companies/${this.uuid}`,
        method: 'PUT',
        params: this.data
      }
      await request(params).then(response => {
        this.data = response.data.data
        if (!empty(this.file)) this.updloadImage()
        else window.location.href = `/organizations/${this.uuid}`
      })       
    },
    async updloadImage () {
      const form = new FormData()
      form.append('file', this.file)
      const params = {
        url: `companies/${this.uuid}/logo`,
        method: 'PUT',
        params: form
      }
      await request(params).then(response => {
        this.data = response.data.data
        window.location.href = `/organizations/${this.uuid}`
      })   
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      const reader = new FileReader()
      console.log(this.file)

      // Leemos el archivo subido y se lo pasamos a nuestro fileReader
      reader.readAsDataURL(this.$refs.file.files[0])

      // Le decimos que cuando este listo ejecute el código interno
      const app = this
      reader.onload = function () {
        app.logo = reader.result
        console.log(app.logo)
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    },
    valid () {
      if (!empty(this.data.name) && !empty(this.data.address) && !empty(this.data.contact_name) && !empty(this.data.phone_number)) return true
      else return false
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.update()
    }
  }
}
</script>
